import AnalyticsTable from "../../../features/supervision/analytics/components/AnalyticsTable/AnalyticsTable";
function AnalyticsList() {
    return <AnalyticsTable/>
}

export default AnalyticsList;